import React from 'react'
import { Trans } from '@mc/i18n'
import { PrivacyLink, TermsLink } from '../../links'

export const SubmitLegal = ({ className = '' }: { className?: string }) => (
  <p className={className}>
    <Trans i18nKey='emailCapture.submit' ns='@mc/legal'>
      <TermsLink />
      <PrivacyLink />
    </Trans>
  </p>
)
